import React from "react";
import ReactDOM from "react-dom";
import App from "./views/App.js";

import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";

ReactDOM.render(<App />, document.getElementById("root"));